import React, {Component} from "react";
import './Beginners.css';
import begin1a from '../../../../../assets/img/begin1a.png';
import begin2new from '../../../../../assets/img/begin2new.png';
import begin3new from '../../../../../assets/img/begin3new.png';
import begin4new from '../../../../../assets/img/begin4new.png';
import begin5new from '../../../../../assets/img/begin5new.png';
import begin6new from '../../../../../assets/img/begin6newCredit.png';
import begin7new from '../../../../../assets/img/begin7new.png';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import MetaTags from "react-meta-tags";


class Beginners extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <div className="static-pages">
                <MetaTags>
                    <title>はじめての方｜プリント基板のネット通販｜KITCUT PCB </title>
                    <meta property="title" content="はじめての方｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="はじめての方｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div ">
                    <div>
                        <img src={begin1a} className="img-begin2"/>
                    </div>


                    <div>
                        <div>
                            <p className="static-pages-headings">
                                <FormattedMessage id="app.beginner.beginnersheading"
                                                  defaultMessage="For beginners"
                                                  description=""
                                />
                            </p>

                        </div>


                        <div>
                            <p className=" beginner-normal-txt all-content-font-size">



                                ようこそ、プリント基板通販 キットカットラボのサイトにお越しいただき、誠に有難うございます。
                                <br/>
                                私たちキットカットラボは、プリント基板・メタルマスク・電子部品をはじめとする、モノづくりに
                                {/*<br/>*/}
                                関わる商品を24時間365日、すべてのモノづくり企業の方が気軽にご利用できるよう、どのサービスや商品においても一般的な国内でのご予算よりも 競争力のある価格を設定させていただきます。
                                <br/>
                                みなさまのアイデアが具現化するまでサポートができれば幸いです。



                            </p>

                        </div>
                    </div>


                    <br/>
                    <div>
                        <div className="spacer"></div>
                        <div>
                            <div className="text-center link-text-font-24" id="middle-txt">
                                <FormattedMessage id="app.beginner.idea"
                                                  defaultMessage="That idea of you will change the world!"
                                                  description=""
                                />
                            </div>
                        </div>
                        <div>
                            <div className="begin-button-div signup-btn">
                                <Link to="/register">
                                    <button id="beginner-btn">
                                        <FormattedMessage id="app.beginner.signupbtn"
                                                          defaultMessage="Tap here to signup"
                                                          description=""
                                        />
                                    </button>
                                </Link>

                            </div>
                        </div>
                    </div>

                    <br/>
                    <br/>

                    <div>
                        <div>
                            <p className="static-pages-headings">
                                KITCUT PCB
                                <FormattedMessage id="app.beginner.keycutpcb"
                                                  defaultMessage="Characteristics of"
                                                  description=""
                                />
                            </p>
                        </div>

                        <div className="row">
                            <table>
                                <tr className="col-md-12 align-content-beginners align-img-center">
                                    <div className="col-md-4">
                                        <img src={begin2new}
                                             className="img-size-beginners"
                                        />
                                       <div className="padding-text-align-beginers">
                                            <span>世界最大級の試作基板工場との独自
                                                </span><br/>
                                           <span>システム連携を実現。</span>
                                       </div>

                                    </div>
                                    <div className="col-md-4">
                                        <img src={begin3new}
                                             className="img-size-beginners"
                                        />
                                        <div className="padding-text-align-beginers">
                                            <span>お受けするプリント基板を少数
                                                低予算</span><br/>
                                            <span>でもご利用いただけるよう
                                                片面から6層までの試作基板に特化。</span>
                                        </div>

                                    </div>
                                    <div className="col-md-4">
                                        <img src={begin4new}
                                             className="img-size-beginners"
                                        />
                                       <div className="padding-text-align-beginers">
                                            <span>
                                                ビジネスで重要なのはスピード。
                                                <br/>
                                                お客様のアイデアをすぐに形にできるよう、
                                            </span><br/>
                                           <span>
                                                製造イニシャルコストが全て無料。
                                            </span>
                                       </div>
                                    </div>
                                </tr>
                                <tr className="col-md-12 align-content-beginners align-img-center">
                                    <div className='col-md-4'>
                                        <img src={begin5new}
                                             className="img-size-beginners"
                                        />
                                        <div className="padding-text-align-beginers">
                                            <span>
                                            お申込み・データアップロードデータチェック・進捗追跡・決済まで全てインターネットで完結のためコストを大きく削減できます。結果、世界最安水準でプリント基板料そのものを安くできるのです。 </span>

                                        </div>

                                    </div>

                                    <div className='col-md-4 paypal-image-resp-div'>
                                        <img src={begin6new}
                                             className="img-size-beginners-increase paypal-image-resp"
                                        />
                                        <div className="padding-text-align-beginers">
                                            <p>
                                                VISA、MASTER、AMERICAN EXPRESSの
                                                3大カード会社に対応、Stripeの決済システムを利用しているのでセキュリティも万全、
                                                {/*3大カード会社に対応、Stripeの決済システムを利用すしているのでセキュリティも万全、*/}
                                                安心してカード払いをご利用いただけます。
                                            </p>
                                        </div>

                                    </div>
                                    <div className='col-md-4'>
                                        <img src={begin7new}
                                             className="img-size-beginners"
                                        />

                                        <div className="padding-text-align-beginers">

                                            <p>
                                                <FormattedMessage id="app.beginner.shipping1"
                                                                  defaultMessage="Inspection, packing, and shipping taking"
                                                                  description=""
                                                />
                                                <FormattedMessage id="app.beginner.shipping2"
                                                                  defaultMessage="advantage of the advantages of Hong Kong,"
                                                                  description=""
                                                />
                                                <FormattedMessage id="app.beginner.shipping3"
                                                                  defaultMessage="which is the control base.   Take"
                                                                  description=""
                                                />
                                                <FormattedMessage id="app.beginner.shipping4"
                                                                  defaultMessage="advantage of Sagawa Express's home delivery"
                                                                  description=""
                                                />
                                                <FormattedMessage id="app.beginner.shipping5"
                                                                  defaultMessage="transport network Use door-to-door international"
                                                                  description=""
                                                />
                                                <FormattedMessage id="app.beginner.shipping6"
                                                                  defaultMessage="courier service for Japan Use Sgx flights."
                                                                  description=""
                                                />
                                                <FormattedMessage id="app.beginner.shipping7"
                                                                  defaultMessage="(Sagawa Express from overseas)"
                                                                  description=""
                                                />
                                                <br/>



                                            </p>
                                        </div>

                                    </div>
                                </tr>

                            </table>


                        </div>


                    </div>
                </div>
            </div>
        );
    }
}

export default Beginners;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Beginners.js